import React from 'react';

const FlipText = ({ texts, prefix }) => {
  
    return (
      <div className="outer-prefix">
        <div className="main-font white-text description-text" style={{display: 'flex', alignItems: 'flex-start', textAlign: 'start'}}>
          {prefix}
          <div className="inner-flip-content">
            <span>
              {texts.map((text, index) => (
                <React.Fragment key={index}>
                  {text}
                  {index < texts.length - 1 && <br/>}
                </React.Fragment>
              ))}
            </span>
          </div>
        </div>
      </div>
    );
};

export default FlipText;